<template>
  <div
    class="header"
    :class="{ [`bg-${type}`]: type }"
    style="min-height: 175px"
  >
    <div class="container-fluid">
      <div class="header-body">
        <slot></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "base-header",
  props: {
    type: {
      type: String,
      default: "primary",
      description: "Header background type",
    },
  },
};
</script>
<style></style>
